import {
  GET_INT_SPECIALITY_BY_CUSTOMER_REQUEST,
  GET_INT_SPECIALITY_BY_CUSTOMER_SUCCESS,
  GET_INT_SPECIALITY_BY_CUSTOMER_ERROR
} from "../actions/types";

export const specialityByCustomerINT = (state = [], action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_INT_SPECIALITY_BY_CUSTOMER_REQUEST:
      return {
        loading: true,
      };
    case GET_INT_SPECIALITY_BY_CUSTOMER_SUCCESS:
      return {
        ...state,
        loading: false,
        payload,
      };
    case GET_INT_SPECIALITY_BY_CUSTOMER_ERROR:
      return {
        ...state,
        loading: false,
        payload,
      };

    default: {
      return state;
    }
  }
};
